import React from 'react'
import PropTypes from 'prop-types'
import Typography from '@material-ui/core/Typography'
import Select from 'react-select'
import { withStyles } from '@material-ui/core/styles'
import { styles } from '../../containers/dockPadStyle'
import classNames from 'classnames'
import { compose } from 'redux'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemAvatar from '@material-ui/core/ListItemAvatar'
import ListItemText from '@material-ui/core/ListItemText'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import { withFirebase } from 'react-redux-firebase'
import { connect, batch } from 'react-redux'

import Menu from '@material-ui/core/Menu';
import Divider from '@material-ui/core/Divider';
import MaterialMenuItem from '@material-ui/core/MenuItem';


import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import Button from '@material-ui/core/Button'
import { homeActions, getNewId } from '../../actions/home.actions'
import Dropzone from 'react-dropzone'
import LinearProgress from '@material-ui/core/LinearProgress'
import { entityActions, isDateOrderCorrect, isValidUploadDate } from '../../actions/entity.actions'
import ReactDataSheet from 'react-datasheet'

import moment, { Moment } from 'moment'

// Be sure to include styles at some point, probably during your bootstrapping
import 'react-datasheet/lib/react-datasheet.css'
import '../../containers/App.css'
import '../../containers/SpreadSheet.css'
import { getProjectId } from '../../selectors/project.selector'
import { getLookaheadTagsList, getLookaheadTradesList } from '../../selectors/lookahead.selector'
import { LookaheadTag } from '../../models/LookaheadTag'
import { ThunkDispatch } from 'redux-thunk'
import { isUploadTasksDialogOpen } from '../../selectors/dialog.selector'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { Trade } from '../../models/Trade'
import { getTradesSelectList } from '../../selectors/phaseplan.selector'

var t = require('tcomb-validation')
var _ = require('lodash')

type SelectEditorOption = {
  label: string,
  value: string
}

interface SelectEditorProps {
  options: SelectEditorOption[],
  value: any
}


interface Props {
  tradeList: Trade[],
  uploadTags: (tags: TagToBeUploaded[]) => void,
  closeDialogValue: () => void,
  isUploadTasksDialogOpen: boolean
}

export type ResolutionValue = {
  value: string | number,
  id: string
}

export type Resolution = ResolutionValue[]

type State = {
  tradeResolutionMenu: any,
  onTradeResolutionCommit: (e:any) => void,
  newTrades: SelectEditorOption[],
  resolutionGrid: Resolution[],
  count: number,
  hasErrors: boolean,
  taskToBeUploaded: any,
  grid: any,
  highlighted: {}
}

type UnZippedImportTag = {
  uid: string,
  zippedData: ImportTag
}
export type ImportTag = {
  name: string,
  startDate: string,
  endDate: string
}

export type TagToBeUploaded = {
  name: string,
  startDate: string,
  endDate: string,
  tradeId: string,
  crewSize: number | null,
  groupName: string | null,
  locationId: string | null
}



export const NEW_TRADE = "NEW_TRADE"

class UploadTasksDialog extends React.PureComponent<Props, State> {

  columns = [
    { readOnly: true, id: 'uid', value: '' },
    { value: 'Name*', id: 'name', readOnly: true },
    { value: 'Start Date*', id: 'startDate', readOnly: true },
    { value: 'End Date*', id: 'endDate', readOnly: true },
    { value: 'Responsible/Trade*', id: 'trade', readOnly: true },
    { value: 'Location', id: 'locationId', readOnly: true },
    { value: 'Crew', id: 'crewSize', readOnly: true },
    { value: 'Group', id: 'groupName', readOnly: true }


  ]

  resolutionColumns = [
    { readOnly: true, id: 'uid', value: '' },
    { value: 'Importing Tags', id: 'importingTasks', readOnly: true },
    { value: 'Trade', id: 'trade', readOnly: true }

  ]

  typeOptions = [{ value: 'tasks', label: 'Task' }]

  constructor(props) {
    super(props)
    const initNumberOfRow = 10
    const emptyRow = Array.apply(null, Array(initNumberOfRow)).map((x, i) => {
      return this.createEmptyRow(i)
    })
    this.state = {
      count: initNumberOfRow,
      grid: [...emptyRow],
      hasErrors: false,
      taskToBeUploaded: null,
      highlighted: {}
    }
  }

  createEmptyRow(count) {
    const counter = count != null ? count : this.state.count
    const newRow = this.columns.map(item => {
      let component = null
      if (item.type == 'select') {
        component = this.selectComp(counter)
      }
      const r = {
        value: null,
        id: item.id,
        component: component
      }
      return r
    })
    newRow[0].value = counter
    newRow[0].readOnly = true

    this.setState({
      count: counter + 1
    })
    return newRow
  }

  handleClose() {
    this.setState({
      taskToBeUploaded: null
    })
  }

  closeDialog = async () => {
    const { closeDialogValue } = this.props
    closeDialogValue()
  }

  onFilesDrop(files) {
    const { dispatch, projectId } = this.props
    const newFileId = getNewId(
      this.props.firebase,
      projectId,
      'tasksUpload'
    )
    const file = files[0]

    const fileBeingUploaded = {
      uid: newFileId,
      name: file.name
    }

    this.setState({
      fileBeingUploaded: fileBeingUploaded
    })
    dispatch(
      entityActions.saveUploadTasksTask(
        projectId,
        fileBeingUploaded.uid,
        fileBeingUploaded.name,
        files
      )
    )
  }

  renderUploadContent() {
    if (!this.state.fileBeingUploaded) {
      return (
        <React.Fragment>
          {this.renderErrorMessage()}

          <DialogContentText id='alert-dialog-description'>
            Upload any Excel or CSV file from your scheduling software
          </DialogContentText>
          <ReactDataSheet
            onSelect ={(start, end) => {
              this.setState({
                highlighted: {
                  start: start.start.i,
                  end: start.end.i
                }
              })
            }}
            attributesRenderer={cell => ({ 'cell-error': cell.error } || {})}
            data={[this.columns, ...this.state.grid]}
            valueRenderer={cell => cell.value}
            onContextMenu={(e, cell, i, j) =>
              cell.readOnly ? e.preventDefault() : null
            }
            onCellsChanged={(changes, additions) => {
              const additionsOpt = !!additions ? additions : []
              let grid = this.state.grid.map(row => [...row])
              changes.forEach(({ cell, row, col, value }) => {
                if (!!grid[row - 1][col]) {
                  grid[row - 1][col] = { ...grid[row - 1][col], value }
                }
              })
              additionsOpt.forEach(({ row, col, value }) => {
                if (!grid[row - 1]) {
                  const newRow = this.createEmptyRow()
                  grid = [...grid, newRow]
                }

                grid[row - 1][col] = { ...grid[row - 1][col], value }
              })
              this.setState({ grid })
            }}
          />
        </React.Fragment>
      )
    }
  }

  selectComp = id => {
    return (
      <Select
        autofocus
        openOnFocus
        onChange={item => {
          const foundRow = this.state.grid.findIndex(element => {
            return element[0].value === id
          })
          if (foundRow >= 0) {
            let grid = this.state.grid
            const row = grid[foundRow] // Array of objects with value
            grid[foundRow][1]['value'] = item.label
            this.setState({
              grid: grid
            })
          }
        }}
        options={this.typeOptions}
      />
    )
  }

  AddRowClick() {
    const newRow = this.createEmptyRow()

    this.setState({
      grid: [...this.state.grid, newRow]
    })
  }

  handleTradeResolutionButtonClick = (event:any, onCommit: (e:any) => void) => {
    if (!!this.state.tradeResolutionMenu) return;
    event.persist()
		this.setState({
      tradeResolutionMenu: event.currentTarget,
      tradeResolutionEvent: event,

      onTradeResolutionCommit: onCommit
		});
  }

  handleTradeSelect = (trade: SelectEditorOption | undefined) => {
    const { onTradeResolutionCommit, tradeResolutionEvent } = this.state 
    //this.props.filterTagsByTrade(trade)
    if(!!trade) {
      onTradeResolutionCommit(trade.value, tradeResolutionEvent)
      this.handleTradeResolutionMenuClose()
    }
  }
  
  handleTradeResolutionMenuClose = () => {
		this.setState({ 
      tradeResolutionMenu: null,
      onTradeResolutionCommit: null,
      tradeResolutionEvent: null
     });
  }

  getTradeList = (): SelectEditorOption[] => {
    const { tradeList } = this.props
    const { newTrades } = this.state

    const tradeSelectList = tradeList.map(trade => {
      return {
        label: trade.name,
        value: trade.uid
      }
    })


    return [...newTrades, ...tradeSelectList ]
  }
  
  renderTradeMenu  = () => {

		return (
			<Menu
				anchorEl={this.state.tradeResolutionMenu}
				open={!!this.state.tradeResolutionMenu}
				onClose={this.handleTradeResolutionMenuClose}
			>
				{
					this.getTradeList().map((trade:SelectEditorOption) => {
						return (
							<MaterialMenuItem key={trade.value} onClick={(e) => this.handleTradeSelect(trade)}> {trade.label} </MaterialMenuItem>
						)
					})
				}
			</Menu>
		)
  }
  
  getValueLabel = (value:string) => {
    const trade = this.getTradeList().find(item => item.value === value)
    return !!trade ? trade.label : ""
  }

  SelectViewer = ( props:any) => {
   
    const { value, onCommit, onRevert } = props

    return (
      <Button fullWidth={true} size="small" color="primary" onClick={(e) => this.handleTradeResolutionButtonClick(e, onCommit)}>
								{value}
							<ArrowDropDownIcon style={{color: '#fff'}} />
				</Button>
    )
  }

  RemoveRowClick() {
    const { count, highlighted, grid } = this.state
    if (count <= 0) {
      return
    }
    if(!!highlighted) {
      const newGrid = grid
      newGrid.splice(highlighted.start - 1, Math.abs(highlighted.end - highlighted.start)+1)
      newGrid.forEach((grid, idx) => {
        grid[0]['value'] = idx
      })

      this.setState({
        grid: newGrid,
        count: count - (Math.abs(highlighted.end - highlighted.start) + 1)
      })
    }
   
  }

  getRowsWithType(grid) {
    return grid.filter(item => {
      const type = item[1].value
      return this.typeOptions.some(opt => {
        return opt.label == type
      })
    })
  }

  findTradeByName = (newTradeName:string) => {
    const { tradeList } = this.props

    const foundTrades = tradeList.find(trade => trade.name === newTradeName)

    return foundTrades
  }

  componentDidUpdate(prevProps:Props, prevState: State) {
    if(this.props.isUploadTasksDialogOpen !== prevProps.isUploadTasksDialogOpen) {
      const initNumberOfRow = 10
      const emptyRow = Array.apply(null, Array(initNumberOfRow)).map((x, i) => {
        return this.createEmptyRow(i)
      })
      this.setState({
        count: initNumberOfRow,
        grid: [...emptyRow],
        hasErrors: false,
        taskToBeUploaded: null
      })
    }
  }

  onUploadTasksClick() {
    const grids = this.state.grid
    let errorCount = 0
    //validate rows

    const validationMap = grids.filter(item => 
      !!item[1].value 
      && !!item[2].value
      && !!item[3].value
      && !!item[4].value
    )
    .reduce((obj, item) => {
      const zipped = _.merge(
        {},
        ...this.columns.map((n, index) => {
          const value = item[index].value
          return { [n.id]: value }
        })
      )

      
      if(!isValidUploadDate(item[2].value) || !isValidUploadDate(item[3].value) ) {
        errorCount += 1
      }

      if(!isDateOrderCorrect(item[2].value, item[3].value)) {
        errorCount += 1
      }
  
      //errorCount += errors.length

      obj[item[0].value] = {
        uid: item[0].value,
        zippedData: zipped
      }

      return obj
    }, {})

    // Check if any row is invalid
    if (errorCount <= 0) {

      const rows: Resolution[] = Object.values(validationMap).filter((item: UnZippedImportTag) => !!item.zippedData && 
        !! item.zippedData.trade &&
        !!item.zippedData.name && 
        !!item.zippedData.startDate &&

        !!item.zippedData.endDate).map(item => {

        const foundTrade = this.findTradeByName(item.zippedData.trade)
        let tradeId
        if(!foundTrade) {
          tradeId = `${NEW_TRADE}/${item.zippedData.trade}`
        } else {
          tradeId = foundTrade.uid
        }

        return [
          { value: item.zippedData.uid, id: 'ID', readOnly: true },
          { value: item.zippedData.name, id: 'Name', readOnly: true },
          { value: tradeId, id: "tradeId", dataEditor: this.SelectViewer.bind(this) }
        ]
      })


      const newTrades = Object.values(validationMap).filter((item: UnZippedImportTag) => !!item.zippedData &&
        !! item.zippedData.trade && 
        !!item.zippedData.name && 
        !!item.zippedData.startDate && 
        !!item.zippedData.endDate &&
        !this.findTradeByName(item.zippedData.trade)
        ).map(item => {
          return {
            label: `${item.zippedData.trade} - New Trade`,
            value:`${NEW_TRADE}/${item.zippedData.trade}`
          }
        })
      this.setState({
        hasErrors: false,
        taskToBeUploaded: validationMap,
        resolutionGrid: rows,
        newTrades
      })
      return
    }

    if(errorCount > 0) {
      this.setState({
        hasErrors: true
      })
    }
  }

  renderButton() {
    if (!this.state.fileBeingUploaded) {
      return (
        <React.Fragment>
          <Button
            onClick={() => {
              this.closeDialog()
            }}
            color='primary'>
            Cancel
          </Button>
          <Button onClick={this.RemoveRowClick.bind(this)} color='primary'>
            Remove Row
          </Button>
          <Button onClick={this.AddRowClick.bind(this)} color='primary'>
            Add Row
          </Button>
          <Button onClick={this.onUploadTasksClick.bind(this)} color='primary'>
            Upload
          </Button>
        </React.Fragment>
      )
    } else {
      return (
        <React.Fragment>
          <Button color='primary'>Cancel</Button>
        </React.Fragment>
      )
    }
  }

  renderErrorText() {

    if(this.state.hasErrors) {
      return (
        <React.Fragment>
          Please fix the errors <br />

        </React.Fragment>
      )
    }
  }

  renderErrorMessage() {

    let color = ''
    if (this.state.hasErrors) { 
      color = 'red'
    }
    return (
      <DialogContentText style={{ color: color }}>
        {this.renderErrorText()}
        * {moment().format('l')} is a valid date format <br />
        * {moment().format('DD-MMM-YY')} is a valid date format <br />
        * {moment().format('MM-DD-YYYY')} is a valid date format <br />

        * Start Date must be before End Date <br />


      </DialogContentText>
    )
  }

  renderTasksResolver() {
    const { tradeList } = this.props
    return (
      <React.Fragment>
        <DialogContentText id='alert-dialog-description'>
        </DialogContentText>
        <ReactDataSheet
          data={[this.resolutionColumns, ...this.state.resolutionGrid]}
          valueRenderer={(cell, i, j) => {
            if(j === 2) {
              const tagFound = this.getTradeList().find(item => item.value == cell.value)
              return !!tagFound ? tagFound.label  : ""
            }
            return cell.value
          }}

          onContextMenu={(e, cell, i, j) =>
            cell.readOnly ? e.preventDefault() : null
          }
          onCellsChanged={changes => {
            const resolutionGrid = this.state.resolutionGrid.map(row => [
              ...row
            ])

            changes.forEach(({ cell, row, col, value }) => {
              if (col == 2 && !!value) {
                const tagFound = this.getTradeList().find(item => item.value == value)
                const newValue = tagFound?.value

                resolutionGrid[row - 1][col] = {
                  ...resolutionGrid[row - 1][col],
                  value: newValue
                }
              }
            })

            this.setState({ resolutionGrid })
          }}
        />
      </React.Fragment>
    )
  }

  importTasks() {
    const resolutionGridInfo = this.state.resolutionGrid
    const pendingTaskMap = Object.assign({}, this.state.taskToBeUploaded)

    const { uploadTags } = this.props


    const data: TagToBeUploaded[] = Object.values(pendingTaskMap).filter((item: UnZippedImportTag)  => {
      const tradeResolution = resolutionGridInfo[parseInt(item.uid)]

      return (
        !!item.zippedData && 
        !!item.zippedData.startDate &&
        !!item.zippedData.endDate &&
        !!item.zippedData.name &&
        !!tradeResolution
      )
    }).map((item: UnZippedImportTag) => {
      const tradeResolution = resolutionGridInfo[parseInt(item.uid)]

        return {
          ...item.zippedData,
          tradeId: `${tradeResolution[2].value}`
        }
    })

    //save map of tasks
    batch(() => {
      uploadTags(data)
      this.closeDialog()
    })
  }

  renderUploadContainer() {
    if (!!this.state.taskToBeUploaded) {
      return (
        <React.Fragment>
          {this.renderTradeMenu()}
          <DialogTitle id='simple-dialog-title'>Confirm Tags To Be Imported</DialogTitle>
          <DialogContent>{this.renderTasksResolver()}</DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                this.closeDialog()
              }}
              color='primary'>
              Cancel
            </Button>
            <Button onClick={this.importTasks.bind(this)} color='primary'>
              Import
            </Button>
          </DialogActions>
        </React.Fragment>
      )
    } else {
      return (
        <React.Fragment>
          <DialogTitle id='simple-dialog-title'>Upload Tasks</DialogTitle>
          <DialogContent>{this.renderUploadContent()}</DialogContent>
          <DialogActions>{this.renderButton()}</DialogActions>
        </React.Fragment>
      )
    }
  }

  render() {
    const { isUploadTasksDialogOpen } = this.props

    return (
      <Dialog
        open={isUploadTasksDialogOpen}
        maxWidth={'lg'}
        onClose={this.handleClose.bind(this)}
        onBackdropClick={this.closeDialog.bind(this)}
        aria-labelledby='simple-dialog-title' >
        {this.renderUploadContainer()}
        
      </Dialog>
    )
  }
}

const mapStateToProps = (state:any) => ({
  projectId: getProjectId(state),
  isUploadTasksDialogOpen: isUploadTasksDialogOpen(state),
  tradeList: getLookaheadTradesList(state)
})

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>) => {
  return {
    uploadTags: (data: any[]) => dispatch(entityActions.uploadTasks(data)),
    closeDialogValue: () => dispatch(homeActions.closeUploadTasksDialog())
  }
}

export default compose(
  withFirebase,
  withStyles(styles, { withTheme: true }),
  connect(mapStateToProps, mapDispatchToProps),

)(UploadTasksDialog)



// WEBPACK FOOTER //
// ./src/components/Dialogs/UploadTasksDialog.tsx